import React from "react";
import { BookOpen } from "lucide-react";
import { HighlightCard } from "../highlights/HighlightCard";

const SOURCE_LABELS = {
  wikipedia:    "Wikipedia",
  arxiv:        "arXiv",
  pubmed:       "PubMed",
  patent_uspto: "USPTO Patent",
  patent_epo:   "Espacenet",
};

const SOURCE_COLORS = {
  wikipedia:    "bg-blue-50 text-blue-700 border-blue-200",
  arxiv:        "bg-orange-50 text-orange-700 border-orange-200",
  pubmed:       "bg-emerald-50 text-emerald-700 border-emerald-200",
  patent_uspto: "bg-purple-50 text-purple-700 border-purple-200",
  patent_epo:   "bg-violet-50 text-violet-700 border-violet-200",
};

export const KnowledgeResults = ({ query, cards, params }) => {
  if (!cards?.length) return null;
  const qs = params ? params.toString() : `q=${encodeURIComponent(query)}`;
  return (
    <section className="mt-12" data-testid="knowledge-results-section">
      {/* Header */}
      <div className="flex items-start gap-3 mb-6 pb-4 border-b border-[var(--hairline)]">
        <BookOpen size={18} className="text-[var(--muted)] shrink-0 mt-0.5" />
        <div>
          <h2 className="font-serif text-xl leading-tight" data-testid="knowledge-results-heading">
            Knowledge Base
          </h2>
          <p className="text-xs text-[var(--muted)] mt-0.5">
            Reference results from Wikipedia, arXiv, PubMed, USPTO and Espacenet · not a news story
          </p>
        </div>
      </div>

      {/* Cards grid — same layout as search results */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
        data-testid="knowledge-cards-grid"
      >
      {cards.map(card => (
          <div key={card.id} className="flex flex-col min-w-0" data-testid={`knowledge-card-${card.id}`}>
            <HighlightCard
              story={card}
              testIdPrefix="kb"
              from={{ path: `/search?${qs}`, label: "DNH Search" }}
              topicBrief={{
                href: `/knowledge/${card.id}/brief?${new URLSearchParams({ q: query })}`,
                sourceCount: 1,
                origins: 1,
                publisher: SOURCE_LABELS[card.kb_source] || card.source_name,
                label: "Read knowledge brief",
                prepare: true,
              }}
              searchFeedback={{ query, itemId: card.id, prefix: `kb-feedback-${card.id}` }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};
